import React from 'react';

import './MenuItem.css';

const MenuItem = ({title, price, tags,}) => (
  <div className='text-white mb-4 '>
   <div className="div flex flex-row   justify-between w-full mb-2 items-center">
    <div className="div">
      <p className='text-yellow-200'>{title}</p>
    </div>
    <div className='bg-white w-28 h-[1px] mx-4' />
    <div className="div text-white">
        <p>{price}</p>
    </div>
   </div>
   <div className="div">
    <p className='text-gray text-xs'>{tags}</p>
   </div>
  </div>
);

export default MenuItem;
